const RouteNames = {
   // USER
   userAddForm: "/user/add-user",
   userList: "/user/user-List",
   userEdit: "/user/update-user/:id",

   // FLEET MASTER
   fleetMasterAddForm: "/fleet-master/add-form",
   fleetMasterList: "/fleet-master/list",
   fleetMasterEdit: "/fleet-master/edit",
   fleetMasterView: "/fleet-master/view/:id",

   // DRIVER MASTER
   driverMasterAddForm: "/driver-master/add-form",
   driverMasterView: "/driver-master/view",
   driverMasterEdit: "/driver-master/edit/:id",

   // HELPER MASTER
   helperMasterAddForm: "/helper-master/add-form",
   helperMasterView: "/helper-master/view",
   helperMasterEdit: "/helper-master/edit/:id",

   // CUSTOMER MASTER
   customerMasterAddForm: "/customer-master/add-form",
   customerMasterView: "/customer-master/view",
   customerMasterEdit: "/customer-master/edit/:id",

   // VENDOR MASTER
   vendorMasterAddForm: "/vendor-master/add-form",
   vendorMasterView: "/vendor-master/view",
   vendorMasterEdit: "/vendor-master/edit/:id",

   // LANE MASTER
   LaneMasterAddForm: "/lane-master/add-form",
   laneMasterView: "/lane-master/view",
   laneMasterEdit: "/lane-master/edit/:id",

   // CONTRACTOR MASTER
   ContractorMasterAddForm: "/contractor-master/add-form",
   contractorMasterView: "/contractor-master/view",
   contractorMasterEdit: "/contractor-master/edit/:id",

   // LOCATION MASTER
   LocationMasterAddForm: "/location-master/:formType",
   LocationMasterView: "/location-master/view",
   LocationMasterEdit: "/location-master/:formType/:id",

   // ADHOC TRIP
   adhocTripAdd: "/trip/adhoc/add",
   adhocTripView: "/trip/adhoc/view",
   adhocTripEdit: "/trip/adhoc/edit/:id",

   // CONTRACTUAL TRIP
   contaractualTripAdd: "/trip/contractual/add",
   contractualTripView: "/trip/contractual/view",
   contractualTripEdit: "/trip/contractual/edit/:id",

   // ADHOC LANE
   adhocLaneAdd: "/adhoc-lane/add",
   adhocLaneView: "/adhoc-lane/view",
   adhocLaneEdit: "/adhoc-lane/edit/:id",

   // ADHOC VENDOR
   adhocVendorAdd: "/adhoc-vendor/add",
   adhocVendorView: "/adhoc-vendor/view",

   // common pages
   profileView: "/profile",
};
export default RouteNames;
